var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('v-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"console",attrs:{"id":"terminal"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }